import { engineComponent } from "neo-common";
import { Paylines } from "../Paylines";
import { PaylinesSelector } from "../PaylinesSelector";
import { Symbols } from "../Symbols";
import { WinAnimator } from "../WinAnimator";
import { Machine } from "../Machine";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { GameManager } from "../../Managers/GameManager";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../Utils/FrameTimer";
import { WinAnimatorExtended } from "../../CustomComponents/WinAnimatorExtended";
import { FreespinsController } from "./FreespinsController";
import { BackgroundStripElement } from "../../CustomComponents/BackgroundStripElement";
import { ModuleManager } from "../../Managers/ModuleManager";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { Tweens } from "../../Components/Effects/Tweens";
import { TeasingBonus } from "../../CustomComponents/TeasingBonus";
import { PlayList } from "../../Components/Sounds/PlayList";
import { DataManager } from "../../Managers/DataManager";
import { AmbientBackground } from "../../Utils/AmbientBackground";

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends ContainerElement {
    private _controller: FreespinsController;
    private _outroDelay: FrameTimerEventEmitter;

    private _paylines: Paylines;
    private _paylinesSelector: PaylinesSelector;

    private _symbols: Symbols;
    private _machine: Machine;
    private _noWinContainer: ContainerElement;
    private _winAnimator: WinAnimatorExtended;

    private _fsMessageEnd: HTMLElement;
    private _fsMessageEndNoWin: HTMLElement;

    private _wildContainer: ContainerElement;
    private _reelSwitch: SwitchElement;
    private _backgroundStrip: BackgroundStripElement;
    private _ambientParticles: SwitchElement;
    private _highWinsParticles: SwitchElement;
    private _ropeSwitch: SwitchElement;
    private _flareSwitch: SwitchElement;

    private _teasingBonus: TeasingBonus;

    constructor() {
        super();

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        this._teasingBonus = new TeasingBonus();
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        if (this.childs != null) {
            for (var key in this.childs) {
                if (this.childs[key] instanceof Paylines) {
                    this._paylines = this.childs[key];
                }

                if (this.childs[key] instanceof PaylinesSelector) {
                    this._paylinesSelector = this.childs[key];
                }

                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (this.childs[key] instanceof Machine) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimator) {
                    this._winAnimator = this.childs[key];
                }

                if (key === "NoWinContainer" && this.childs[key] instanceof ContainerElement) {
                    this._noWinContainer = this.childs[key];
                }

                if (key === "WildContainer" && this.childs[key] instanceof ContainerElement) {
                    this._wildContainer = this.childs[key];
                }

                if (key === "BackgroundStrip" && this.childs[key] instanceof BackgroundStripElement) {
                    this._backgroundStrip = this.childs[key];
                }

                if (key === "ReelSwitch" && this.childs[key] instanceof SwitchElement) {
                    this._reelSwitch = this.childs[key];
                }

                /*if (key === 'TeasingComponent' && this.childs[key] instanceof TeasingComponent) {
                    this._teasingBonus = this.childs[key];
                }*/

                if (key === "TeasingFront" && this.childs[key] instanceof SwitchElement) {
                    if (this._teasingBonus != null) {
                        this._teasingBonus.addElementInstance({ teasingFront: this.childs[key] });
                    }
                }

                if (key === "TeasingParticles" && this.childs[key] instanceof SwitchElement) {
                    if (this._teasingBonus != null) {
                        this._teasingBonus.addElementInstance({ teasingParticles: this.childs[key] });
                    }
                }

                if (key === "AmbientParticles" && this.childs[key] instanceof SwitchElement) {
                    this._ambientParticles = this.childs[key];
                }

                if (key === "HighWinsParticles" && this.childs[key] instanceof SwitchElement) {
                    this._highWinsParticles = this.childs[key];
                }

                if (key === "RopeSwitch" && this.childs[key] instanceof SwitchElement) {
                    this._ropeSwitch = this.childs[key];
                }

                if (key === "FlareSwitch" && this.childs[key] instanceof SwitchElement) {
                    this._flareSwitch = this.childs[key];
                }
            }

            this._fsMessageEnd = document.getElementById("fsMessageEnd");
            if (this._fsMessageEnd == null) {
                if (DEBUG) {
                    this.log("ERROR no fsMessageEnd");
                }
            }

            this._fsMessageEndNoWin = document.getElementById("fsMessageEndNoWin");
            if (this._fsMessageEndNoWin == null) {
                if (DEBUG) {
                    this.log("ERROR no fsMessageEndNoWin");
                }
            }

            if (this._symbols == null) {
                if (DEBUG) {
                    this.log("ERROR no symbols");
                }
            }

            if (this._machine == null) {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }

            if (this._paylines == null) {
                if (DEBUG) {
                    this.log("WARNING no paylines");
                }
            }

            if (this._winAnimator == null) {
                if (DEBUG) {
                    this.log("WARNING no winAnimator");
                }
            }
        }
    }

    initReceived(controller: FreespinsController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    if (
                        GameManager.freespinsResponse.initData != null &&
                        GameManager.freespinsResponse.initData.reels !== null
                    ) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(this._symbols, GameManager.freespinsResponse.initData.reels);
                        this._machine.addElementInstance({ teasing: [this._teasingBonus] });
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.on(
                            WinAnimator.FinishQuickWinCalculation,
                            this.finishQuickWinCalculation.bind(this),
                        );
                        this._winAnimator.initialize(this._symbols, this._paylines, this._noWinContainer);
                        this._winAnimator.addElementInstance({ wildContainer: this._wildContainer });
                        this._winAnimator.addElementInstance({ teasing: [this._teasingBonus] });
                        this._winAnimator.addElementInstance({ highWinsParticles: this._highWinsParticles });
                        this._winAnimator.addElementInstance({ ropeSwitch: this._ropeSwitch });
                        this._winAnimator.addElementInstance({ flareSwitch: this._flareSwitch });
                    }

                    if (
                        GameManager.freespinsResponse.hasOwnProperty("customData") &&
                        GameManager.freespinsResponse.customData["selectedSymbol"] != null
                    ) {
                        this._backgroundStrip.setActiveScene(
                            GameManager.freespinsResponse.customData["selectedSymbol"],
                        );
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no freespin reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.visible = false;
    }

    disableLogo(): void {
        if (this.childs["Logo"] != null) {
            this.removeChild(this.childs["Logo"]);
        }
    }

    initIntro(): void {
        if (
            GameManager.freespinsResponse.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.customData["selectedSymbol"] != null
        ) {
            switch (GameManager.freespinsResponse.customData["selectedSymbol"]) {
                case 7:
                    PlayList.loop("SND_FSBKGLoopGreen");
                    AmbientBackground.changeAmbientBackground("color-1", 0);
                    break;
                case 8:
                    PlayList.loop("SND_FSBKGLoopBlue");
                    AmbientBackground.changeAmbientBackground("color-2", 0);
                    break;
                case 9:
                    PlayList.loop("SND_FSBKGLoopWhite");
                    AmbientBackground.changeAmbientBackground("color-3", 0);
                    break;
                case 10:
                    PlayList.loop("SND_FSBKGLoopRed");
                    AmbientBackground.changeAmbientBackground("color-4", 0);
                    break;
                case 11:
                    PlayList.loop("SND_FSBKGLoopGold");
                    AmbientBackground.changeAmbientBackground("color-5", 0);
                    break;
            }

            if (this._reelSwitch != null) {
                this._reelSwitch.alpha = 1;
                this._reelSwitch.scale.x = this._reelSwitch.scale.y = 1;
            }

            if (this._backgroundStrip != null) {
                this._backgroundStrip.setActiveScene(GameManager.freespinsResponse.customData["selectedSymbol"]).play();
                this.setSceneAnimations(GameManager.freespinsResponse.customData["selectedSymbol"]);
            }
            ModuleManager.setActiveSceneInBasegame(GameManager.freespinsResponse.customData["selectedSymbol"]);
            ModuleManager.setActiveSceneBackground("base", GameManager.freespinsResponse.customData["selectedSymbol"]);

            if (this._ambientParticles != null) {
                this._ambientParticles.goToCase("PLAY");
            }
        }

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.setCustomData(GameManager.freespinsResponse.customData);
        this._winAnimator.showInitWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);

        this.visible = true;

        if (this.isLastFreespin()) {
            if (!this.getRetriggerCount() || DataManager.GameLimit) {
                PlayList.stop("SND_FSBKGLoopGreen", 10);
                PlayList.stop("SND_FSBKGLoopBlue", 10);
                PlayList.stop("SND_FSBKGLoopWhite", 10);
                PlayList.stop("SND_FSBKGLoopRed", 10);
                PlayList.stop("SND_FSBKGLoopGold", 10);

                PlayList.play("SND_FSEnd");
                PlayList.loop("SND_FSEndLoop", 240);

                if (GameManager.freespinsResponse.totalWin > 0) {
                    if (
                        this._fsMessageEnd != null &&
                        this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)
                    ) {
                        this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                    }
                } else {
                    if (
                        this._fsMessageEndNoWin != null &&
                        this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
                    ) {
                        this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                    }
                }
            }
        }
    }

    spin(): void {
        if (
            GameManager.freespinsResponse.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.customData["selectedSymbol"] != null
        ) {
            switch (GameManager.freespinsResponse.customData["selectedSymbol"]) {
                case 7:
                    PlayList.loop("SND_FSBKGLoopGreen");
                    break;
                case 8:
                    PlayList.loop("SND_FSBKGLoopBlue");
                    break;
                case 9:
                    PlayList.loop("SND_FSBKGLoopWhite");
                    break;
                case 10:
                    PlayList.loop("SND_FSBKGLoopRed");
                    break;
                case 11:
                    PlayList.loop("SND_FSBKGLoopGold");
                    break;
            }
        }

        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }
        this._machine.spinStart(this._winAnimator.reset(false, true));
    }

    stop(): void {
        this._machine.spinStop(null, true);
    }

    startReceived(): void {
        PlayList.stop("SND_FSTransitionMenu");
        PlayList.play("SND_FSTransitionSelect");
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    endReceived(): void {
        //this.outro();
    }

    onReelStopped(): void {
        this._winAnimator.onReelStopped(
            GameManager.freespinsResponse.screen.reels,
            this._machine.actualReelStopped,
            this._machine.forceStop,
        );
    }

    machineStopped(): void {
        this._controller.machineStopped();
        if (GameManager.freespinsResponse.hasOwnProperty("customData")) {
            this._winAnimator.setCustomData(GameManager.freespinsResponse.customData);
        }

        this._winAnimator.showWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);

        if (GameManager.freespinsResponse.currentWin === 0) {
            if (this.isLastFreespin()) {
                if (!this.getRetriggerCount() || DataManager.GameLimit) {
                    PlayList.stop("SND_FSBKGLoopGreen", 10);
                    PlayList.stop("SND_FSBKGLoopBlue", 10);
                    PlayList.stop("SND_FSBKGLoopWhite", 10);
                    PlayList.stop("SND_FSBKGLoopRed", 10);
                    PlayList.stop("SND_FSBKGLoopGold", 10);

                    PlayList.play("SND_FSEnd");
                    PlayList.loop("SND_FSEndLoop", 240);

                    if (GameManager.freespinsResponse.totalWin > 0) {
                        if (
                            this._fsMessageEnd != null &&
                            this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)
                        ) {
                            this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                        }
                    } else {
                        if (
                            this._fsMessageEndNoWin != null &&
                            this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
                        ) {
                            this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                        }
                    }
                }
            }
        }
    }

    private finishQuickWinCalculation(): void {
        this._controller.quickWinCalculationFinished();
    }

    finishWinCalculation(): void {
        this._controller.winCalculationFinished();
    }

    finishWinAnimator(): void {
        this._controller.allWinsFinished();

        if (
            GameManager.freespinsResponse.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.customData["selectedSymbol"] != null
        ) {
            switch (GameManager.freespinsResponse.customData["selectedSymbol"]) {
                case 7:
                    PlayList.loop("SND_FSBKGLoopGreen");
                    break;
                case 8:
                    PlayList.loop("SND_FSBKGLoopBlue");
                    break;
                case 9:
                    PlayList.loop("SND_FSBKGLoopWhite");
                    break;
                case 10:
                    PlayList.loop("SND_FSBKGLoopRed");
                    break;
                case 11:
                    PlayList.loop("SND_FSBKGLoopGold");
                    break;
            }
        }

        if (this.isLastFreespin()) {
            if (!this.getRetriggerCount() || DataManager.GameLimit) {
                PlayList.stop("SND_FSBKGLoopGreen", 10);
                PlayList.stop("SND_FSBKGLoopBlue", 10);
                PlayList.stop("SND_FSBKGLoopWhite", 10);
                PlayList.stop("SND_FSBKGLoopRed", 10);
                PlayList.stop("SND_FSBKGLoopGold", 10);

                PlayList.play("SND_FSEnd");
                PlayList.loop("SND_FSEndLoop", 240);

                if (GameManager.freespinsResponse.totalWin > 0) {
                    if (
                        this._fsMessageEnd != null &&
                        this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)
                    ) {
                        this._fsMessageEnd.classList.remove(HtmlController.DisabledClass);
                    }
                } else {
                    if (
                        this._fsMessageEndNoWin != null &&
                        this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
                    ) {
                        this._fsMessageEndNoWin.classList.remove(HtmlController.DisabledClass);
                    }
                }
            }
        }
    }

    intro(long: boolean = false): void {
        this.visible = true;
        if (
            GameManager.freespinsResponse.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.customData["selectedSymbol"] != null
        ) {
            switch (GameManager.freespinsResponse.customData["selectedSymbol"]) {
                case 7:
                    PlayList.loop("SND_FSBKGLoopGreen");
                    AmbientBackground.changeAmbientBackground("color-1", 400);
                    break;
                case 8:
                    PlayList.loop("SND_FSBKGLoopBlue");
                    AmbientBackground.changeAmbientBackground("color-2", 400);
                    break;
                case 9:
                    PlayList.loop("SND_FSBKGLoopWhite");
                    AmbientBackground.changeAmbientBackground("color-3", 400);
                    break;
                case 10:
                    PlayList.loop("SND_FSBKGLoopRed");
                    AmbientBackground.changeAmbientBackground("color-4", 400);
                    break;
                case 11:
                    PlayList.loop("SND_FSBKGLoopGold");
                    AmbientBackground.changeAmbientBackground("color-5", 400);
                    break;
            }

            if (
                this._backgroundStrip != null &&
                this._backgroundStrip.getLastScene() == GameManager.freespinsResponse.customData["selectedSymbol"]
            ) {
                this._reelSwitch.alpha = 1;
                this._reelSwitch.goToCase(
                    "SELECTED_BUTTON_" + GameManager.freespinsResponse.customData["selectedSymbol"] + "_OUTRO",
                );
            } else {
                if (this._reelSwitch != null) {
                    this._reelSwitch.alpha = 1;
                    this._reelSwitch.scale.x = this._reelSwitch.scale.y = 0.7;
                    this._reelSwitch.goToCase(
                        "SELECTED_BUTTON_" + GameManager.freespinsResponse.customData["selectedSymbol"] + "_OUTRO",
                    );

                    Tweens.scaleTween(this._reelSwitch, {
                        tweenValues: [
                            { x: this._reelSwitch.scale.x, y: this._reelSwitch.scale.y } as PIXI.Point,
                            { x: 1, y: 1 } as PIXI.Point,
                        ],
                        tweenDuration: 60,
                        tweenEase: "power4Out",
                    });
                }
            }

            if (this._winAnimator != null) {
                Tweens.alphaTween(this._winAnimator, {
                    alphas: [0, 1],
                    tweenDelay: 30,
                    tweenDuration: 30,
                });
            }

            if (this._backgroundStrip != null) {
                //disable bg animations just when it goes from one fs scene to another scene
                if (
                    this._backgroundStrip.getLastScene() != GameManager.freespinsResponse.customData["selectedSymbol"]
                ) {
                    this._backgroundStrip.setBackgroundAnimations(this._backgroundStrip.lastAnimationBgScene, false);
                }
                this._backgroundStrip.setActiveScene(GameManager.freespinsResponse.customData["selectedSymbol"]).play();
            }

            if (this._ambientParticles != null) {
                this._ambientParticles.goToCase("PLAY");
            }
        }

        this.introFinished();
    }

    introFinished(): void {
        if (
            GameManager.freespinsResponse.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.customData["selectedSymbol"] != null
        ) {
            switch (GameManager.freespinsResponse.customData["selectedSymbol"]) {
                case 7:
                    PlayList.loop("SND_FSBKGLoopGreen");
                    break;
                case 8:
                    PlayList.loop("SND_FSBKGLoopBlue");
                    break;
                case 9:
                    PlayList.loop("SND_FSBKGLoopWhite");
                    break;
                case 10:
                    PlayList.loop("SND_FSBKGLoopRed");
                    break;
                case 11:
                    PlayList.loop("SND_FSBKGLoopGold");
                    break;
            }
        }

        this._controller.introFinished();
    }

    outro(): void {
        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }
        this._winAnimator.reset(true);

        if (this._ambientParticles != null) {
            this._ambientParticles.goToCase("STOP");
        }

        if (this._fsMessageEnd != null && !this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageEnd.classList.add(HtmlController.DisabledClass);
        }

        if (
            this._fsMessageEndNoWin != null &&
            !this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)
        ) {
            this._fsMessageEndNoWin.classList.add(HtmlController.DisabledClass);
        }

        if (ModuleManager.freespinsEnabled()) {
            Tweens.removeTweens(this._winAnimator);
            Tweens.alphaTween(this._winAnimator, { alphas: [this._winAnimator.alpha, 0], tweenDuration: 60 });
            this._outroDelay.start(60);
        } else {
            Tweens.removeTweens(this._winAnimator);
            Tweens.alphaTween(this._winAnimator, { alphas: [this._winAnimator.alpha, 0], tweenDuration: 15 });

            if (this._backgroundStrip != null) {
                this._backgroundStrip.goToScene(null, 0, 45, 60).play();
                this._backgroundStrip.setBackgroundAnimationsInInterval(0, this._backgroundStrip.getLastScene(), true);
                ModuleManager.setActiveSceneBackground("base", 0);
            }

            if (this._reelSwitch != null) {
                this._reelSwitch.goToCase("OUTRO");

                Tweens.removeTweens(this._reelSwitch);
                Tweens.scaleTween(this._reelSwitch, {
                    tweenValues: [{ x: 1, y: 1 } as PIXI.Point, { x: 0.7, y: 0.7 } as PIXI.Point],
                    tweenDelay: 30,
                    tweenDuration: 30,
                    tweenEase: "power4Out",
                });
            }

            PlayList.stop("SND_FSBKGLoopGreen", 10);
            PlayList.stop("SND_FSBKGLoopBlue", 10);
            PlayList.stop("SND_FSBKGLoopWhite", 10);
            PlayList.stop("SND_FSBKGLoopRed", 10);
            PlayList.stop("SND_FSBKGLoopGold", 10);

            PlayList.stop("SND_FSEndLoop");
            PlayList.play("SND_FSOutro");

            AmbientBackground.changeAmbientBackground("base", 400, 1600);
            this._outroDelay.start(120);
        }
    }

    outroFinished(): void {
        this._outroDelay.stop();

        this.visible = false;
        if (this._reelSwitch != null) {
            this._reelSwitch.scale.set(1, 1);
        }

        //disable last and current scene background animation
        if (this._backgroundStrip != null) {
            if (
                GameManager.freespinsResponse.hasOwnProperty("customData") &&
                GameManager.freespinsResponse.customData["selectedSymbol"] != null
            ) {
                //we go to another fs scene, so we just disable current scene animation
                this._backgroundStrip.lastAnimationBgScene = this._backgroundStrip.getLastScene();
                //this._backgroundStrip.setBackgroundAnimations(this._backgroundStrip.getLastScene(), false);
            } else {
                //we setup new scene in outro, so we lost information about lastScene, therefor we disable all animations fs scenes
                this._backgroundStrip.setAllBackgroundAnimations(false);
            }
        }

        this._controller.outroFinished();
    }

    enable(): void {
        /*PlayList.play('SND_FSWin');

        if (this._fsMessageStart != null && this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
            this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
        }*/
    }

    setSceneAnimations(sceneIndex: number, enabled: boolean = true): void {
        if (this._backgroundStrip != null) {
            this._backgroundStrip.setBackgroundAnimations(sceneIndex, enabled);
        }
    }

    /**
     * Checks last freespin.
     * @returns {boolean}
     */
    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        if (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        ) {
            return true;
        }

        return false;
    }

    /**
     * Get remaining retriggers.
     * @returns {number}
     */
    private getRetriggerCount(): number {
        if (
            GameManager.freespinsResponse.hasOwnProperty("customData") &&
            GameManager.freespinsResponse.customData["retriggerCount"] != null
        ) {
            return GameManager.freespinsResponse.customData["retriggerCount"];
        }

        return null;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/